import { useState } from "react"
import { IconButton, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { scheduleCommentaryLabel } from "../lib/schedule-commentary-label"
import { ScheduleCommentaryPreviewDialog } from "./schedule-commentary-preview-dialog"

export function ScheduleCommentaryPreviewButton({ item }) {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Tooltip title="Preview commentary">
                <IconButton
                    size="small"
                    color="primary"
                    aria-label={`Preview commentary for ${scheduleCommentaryLabel(item)}`}
                    data-cy="schedule-commentary-preview-button"
                    onClick={() => setOpen(true)}
                >
                    <Iconify icon="mdi:eye-outline" />
                </IconButton>
            </Tooltip>
            <ScheduleCommentaryPreviewDialog open={open} onClose={() => setOpen(false)} item={item} />
        </>
    )
}
